<!-- 月销售报表 -->
<template>
  <div id="home">
    <van-nav-bar
      :title="$t('MonthReport.title')"
      left-arrow
      fixed
      :right-text="$t('DayReport.export')"
      @click-left="$router.go(-1)"
      @click-right="onClickExport"
    >
    </van-nav-bar>
    <div class="header">
      <span class="demonstration">年份：</span>
      <el-date-picker
        v-model="date"
        type="year"
        placeholder="选择年"
        @change="getMonthData"
      >
      </el-date-picker>
    </div>
    <div class="chartBox" id="chart"></div>
    <van-cell-group>
      <van-cell>
        <van-row>
          <van-col span="2">{{ $t("MonthReport.m") }}</van-col>
          <van-col span="2">{{ $t("MonthReport.peoopleNum") }}</van-col>
          <van-col span="4">Line Pay</van-col>
          <van-col span="4">{{ $t("payMethod.card") }}</van-col>
          <van-col span="4">{{ $t("payMethod.cash") }}</van-col>
          <van-col span="4">{{ $t("payMethod.other") }}</van-col>
          <van-col span="4"
            >{{ $t("payMethod.totalprice") }} ({{ currency }})</van-col
          >
          <!-- <van-col span="6">{{$t('MonthReport.price')}}({{currency}})</van-col> -->
        </van-row>
        <div slot="right-icon" style="width: 22px;"></div>
      </van-cell>
      <template v-for="(item, index) in monthData">
        <van-cell
          center
          is-link
          :to="{
            path: '/MonthDetail',
            query: { year: year, month: item.month }
          }"
        >
          <van-row>
            <van-col span="2">{{ item.month }}</van-col>
            <van-col span="2">{{ item.number }}</van-col>
            <van-col span="4">{{ item.line_pay }}</van-col>
            <van-col span="4">{{ item.card }}</van-col>
            <van-col span="4">{{ item.price }}</van-col>
            <van-col span="4">{{ item.other }}</van-col>
            <van-col span="4">{{ item.total }}</van-col>
          </van-row>
        </van-cell>
      </template>
    </van-cell-group>
  </div>
</template>
<script>
export default {
  data() {
    return {
      options: {
        title: {
          text: this.$t("MonthReport.title")
        },
        color: ["red"],
        tooltip: {},
        // toolbox: {
        //                    feature: {
        //                        saveAsImage: {
        //                        }
        //                    }
        //                },
        xAxis: {
          name: this.$t("MonthReport.month"),
          data: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"],
          axisTick: {
            alignWithLabel: true
          },
          axisLabel: {
            interval: 0
          }
        },
        yAxis: {
          name: this.$t("MonthReport.money")
        },
        grid: {
          left: "5.5%",
          // right: '1%',
          bottom: "10%",
          containLabel: true
        },
        series: [
          {
            name: this.$t("MonthReport.price"),
            type: "bar",
            label: {
              normal: {
                show: true,
                position: "top"
              }
            },
            data: [10, 20, 15, 30, 40, 10, 5, 30, 50, 16, 28, 60]
          }
        ]
      },
      monthData: [],
      monthChart: "",
      year: new Date().getFullYear(),
      date: new Date(),
      currency: ""
    };
  },
  mounted: function() {
    this.monthChart = this.$echarts.init(document.getElementById("chart"));
    if (sessionStorage.getItem("year")) {
      this.date = new Date(sessionStorage.getItem("year"));
      sessionStorage.removeItem("year");
    }
    this.getMonthData();
    this.getCurrency();
  },
  methods: {
    // 获取月报表
    getMonthData() {
      this.$axios({
        method: "PATCH",
        headers: {
          Authorization: "Bearer " + sessionStorage.token
        },
        url:
          this.$build +
          "/api/store/" +
          sessionStorage.actShopId +
          "/totalMonthIncome",
        data: {
          year: this.date.getFullYear()
        }
      })
        .then(res => {
          console.log(res);
          if (res.data.status == 200) {
            this.monthData = res.data.data;
            this.options.xAxis.data = res.data.month; //横坐标
            this.options.series[0].data = res.data.price; //数值
            this.monthChartInit();
          } else {
            for (var item in res.data.error) {
              this.$toast({
                type: "fail",
                message: res.data.error[item]
              });
            }
          }
        })
        .catch(err => {});
    },
    monthChartInit() {
      this.monthChart.setOption(this.options);
    },
    // 获取店铺设置的货币
    getCurrency() {
      this.$axios({
        method: "get",
        headers: {
          Authorization: "Bearer " + sessionStorage.token
        },
        url:
          this.$build + "/api/store/" + sessionStorage.actShopId + "/currency"
      })
        .then(res => {
          console.log(res);
          if (res.data.status == 200) {
            this.currency = res.data.data.unit;
          } else {
            for (var item in res.data.error) {
              this.$toast({
                type: "fail",
                message: res.data.error[item]
              });
            }
          }
        })
        .catch(err => {
          this.$toast({
            type: "fail",
            message: this.$t("EditDish.message")
          });
        });
    },
    // 导出报表
    onClickExport() {
      window.location.href =
        this.$build +
        "/api/store/" +
        sessionStorage.actShopId +
        "/exportReport?param=totalMonthIncome&year=" +
        this.year;
    }
  }
};
</script>
<style scoped>
/deep/ .van-nav-bar .van-icon {
  font-size: 24px;
  color: #fff;
}
/deep/ .van-cell__left-icon,
.van-cell__right-icon {
  font-size: 22px;
}
/deep/ .van-nav-bar__right .van-nav-bar__text {
  color: #fff;
}
.header {
  padding: 10px;
  background-color: #fff;
}
.chartBox {
  width: 100%;
  min-height: 240px;
  background-color: #fff;
  padding-top: 10px;
}
.content {
  color: #000;
}
.title {
  font-size: 14px;
  color: #444;
}
</style>



// WEBPACK FOOTER //
// src/Report/MonthReport.vue